import * as i0 from '@angular/core';
import { Injectable, Pipe, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { FormGroup, FormControl, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import { DeleteDialogConfigurations } from 'dialog-configuration-library';
import { environment } from 'environment-configurations';
import * as i3 from 'custom-radio-button';
import * as i4 from 'ngx-toastr';
import * as i5 from 'file-upload-library';
import * as i6 from 'reference-library';
import * as i7 from 'primeng/dynamicdialog';
import * as i8 from 'custom-dropdown';
import * as i9 from '@angular/common';
import * as i10 from 'primeng/table';
import * as i11 from 'primeng/api';
import { PrimengLibraryModule } from 'primeng-library';

class LibGenerateReceiptService {
    constructor(http) {
        this.http = http;
        this.formDataIdChanges = new Subject();
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getReceipteNo() {
        return this.http.get(`/vd/formBuilder/invoice/invoiceNumber?type=RECEIPT`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getGenerateReceiptDetails(listId) {
        return this.http.get(`/vd/formBuilder/client/invoice/${listId}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getMenuWithPermissionListById(moduleId) {
        return this.http.get(`/vd/formBuilder/module/${moduleId}/permission/menu/list`)
            .pipe(map((response) => {
            if (response.status === 200 && response.data && response.data.length > 0) {
                return response.data;
            }
            else {
                return [];
            }
        }));
    }
}
LibGenerateReceiptService.ɵfac = function LibGenerateReceiptService_Factory(t) { return new (t || LibGenerateReceiptService)(i0.ɵɵinject(i1.HttpClient)); };
LibGenerateReceiptService.ɵprov = i0.ɵɵdefineInjectable({ token: LibGenerateReceiptService, factory: LibGenerateReceiptService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibGenerateReceiptService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class NumberToWordsPipe {
    transform(value) {
        if (value && isInteger(value))
            return numToWords(value);
        return value;
    }
}
NumberToWordsPipe.ɵfac = function NumberToWordsPipe_Factory(t) { return new (t || NumberToWordsPipe)(); };
NumberToWordsPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "numberToWords", type: NumberToWordsPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumberToWordsPipe, [{
        type: Pipe,
        args: [{
                name: "numberToWords",
            }]
    }], null, null); })();
const isInteger = function (x) {
    return x % 1 === 0;
};
const arr = (x) => Array.from(x);
const num = (x) => Number(x) || 0;
const str = (x) => String(x);
const isEmpty = (xs) => xs.length === 0;
const take = (n) => (xs) => xs.slice(0, n);
const drop = (n) => (xs) => xs.slice(n);
const reverse = (xs) => xs.slice(0).reverse();
const comp = (f) => (g) => (x) => f(g(x));
const not = (x) => !x;
const chunk = (n) => (xs) => isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];
// numToWords :: (Number a, String a) => a -> String
let numToWords = (n) => {
    let a = [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
    ];
    let b = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
    ];
    let g = [
        "",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
    ];
    // this part is really nasty still
    // it might edit this again later to show how Monoids could fix this up
    let makeGroup = ([ones, tens, huns]) => {
        return [
            num(huns) === 0 ? "" : a[huns] + " hundred ",
            num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + "-") || "",
            a[tens + ones] || a[ones],
        ].join("");
    };
    // "thousands" constructor; no real good names for this, i guess
    let thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`);
    // execute !
    if (typeof n === "number")
        return numToWords(String(n));
    if (n === "0")
        return "zero";
    return comp(chunk(3))(reverse)(arr(n))
        .map(makeGroup)
        .map(thousand)
        .filter(comp(not)(isEmpty))
        .reverse()
        .join(" ");
};

function LibGenerateReceiptComponent_div_3_ng_template_55_th_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, "Tax");
    i0.ɵɵelementEnd();
} }
function LibGenerateReceiptComponent_div_3_ng_template_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Resource Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Chargeable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Worked Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, LibGenerateReceiptComponent_div_3_ng_template_55_th_7_Template, 2, 0, "th", 30);
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Total amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedCurrencyType && ctx_r2.selectedCurrencyType.trim() !== "USD");
} }
function LibGenerateReceiptComponent_div_3_ng_template_56_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "span", 32);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 33);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = i0.ɵɵnextContext().rowIndex;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(3, 2, ctx_r8.selectedcurrencyicon, 0, 2));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r8.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r8.invoiceForm.controls["billingItemDTOs"].value[i_r7].taxAmt) ? ctx_r8.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r8.invoiceForm.controls["billingItemDTOs"].value[i_r7].taxAmt : "--", "");
} }
function LibGenerateReceiptComponent_div_3_ng_template_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 31);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵelementStart(4, "span", 32);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 33);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵelementStart(10, "span", 33);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, LibGenerateReceiptComponent_div_3_ng_template_56_td_12_Template, 6, 6, "td", 30);
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵelementStart(14, "span", 32);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "span", 33);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ctx.rowIndex;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroupName", i_r7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].billingItem) ? ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].billingItem : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(6, 8, ctx_r3.selectedcurrencyicon, 0, 2));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].chargeableAmt) ? ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].chargeableAmt : "--");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].hoursWorked) ? ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].hoursWorked : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedCurrencyType && ctx_r3.selectedCurrencyType.trim() !== "USD");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(16, 12, ctx_r3.selectedcurrencyicon, 0, 2));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].totalAmt) ? ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7] == null ? null : ctx_r3.invoiceForm.controls["billingItemDTOs"].value[i_r7].totalAmt : "--", "");
} }
function LibGenerateReceiptComponent_div_3_ng_template_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 34);
    i0.ɵɵelementStart(2, "h5", 35);
    i0.ɵɵtext(3, "Sub total");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 36);
    i0.ɵɵelementStart(5, "span", 37);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 38);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "numberToWords");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(7, 4, ctx_r4.selectedcurrencyicon, 0, 2));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r4.generateReceiptDetails.invoiceTotal, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(11, 8, ctx_r4.generateReceiptDetails.invoiceTotal), " ", ctx_r4.selectedCurrencyType, " only ");
} }
function LibGenerateReceiptComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelement(4, "img", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Receipt");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵelementStart(9, "div", 12);
    i0.ɵɵelementStart(10, "strong");
    i0.ɵɵtext(11, "Receipt No.");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, ": ");
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 12);
    i0.ɵɵelementStart(16, "strong");
    i0.ɵɵtext(17, "Receipt Date");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18, " : ");
    i0.ɵɵelementStart(19, "span");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 13);
    i0.ɵɵelementStart(23, "div", 14);
    i0.ɵɵelementStart(24, "strong");
    i0.ɵɵtext(25, "Bill To");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "div", 15);
    i0.ɵɵelementStart(27, "div", 16);
    i0.ɵɵelementStart(28, "div", 17);
    i0.ɵɵelementStart(29, "strong", 18);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "address");
    i0.ɵɵtext(32);
    i0.ɵɵelement(33, "br");
    i0.ɵɵtext(34);
    i0.ɵɵelement(35, "br");
    i0.ɵɵtext(36);
    i0.ɵɵelement(37, "br");
    i0.ɵɵtext(38);
    i0.ɵɵelement(39, "br");
    i0.ɵɵtext(40);
    i0.ɵɵelement(41, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 19);
    i0.ɵɵelementStart(43, "div");
    i0.ɵɵelementStart(44, "strong");
    i0.ɵɵtext(45, "Reference No. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "span");
    i0.ɵɵtext(47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div");
    i0.ɵɵelementStart(49, "strong");
    i0.ɵɵtext(50, "Invoice No. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "span");
    i0.ɵɵtext(52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 20);
    i0.ɵɵelementStart(54, "p-table", 21);
    i0.ɵɵtemplate(55, LibGenerateReceiptComponent_div_3_ng_template_55_Template, 10, 1, "ng-template", 22);
    i0.ɵɵtemplate(56, LibGenerateReceiptComponent_div_3_ng_template_56_Template, 19, 16, "ng-template", 23);
    i0.ɵɵtemplate(57, LibGenerateReceiptComponent_div_3_ng_template_57_Template, 12, 10, "ng-template", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "div", 25);
    i0.ɵɵelement(59, "div", 26);
    i0.ɵɵelementStart(60, "div", 27);
    i0.ɵɵtext(61, " Powered by ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "div", 28);
    i0.ɵɵelement(63, "img", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(64, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("src", ctx_r0.ownCompanyLogoImage, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate((ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.receiptNumber) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.receiptNumber : ctx_r0.getInvoiceNumber);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.receiptDate) ? i0.ɵɵpipeBind2(21, 15, ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.receiptDate, "shortDate") : "--");
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate((ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.name) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.name : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.addressLine1) ? (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.addressLine1) + "," : "--", " ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.addressLine2) ? (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.addressLine2) + "," : "", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.city) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.city : "--", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.stateProvinceCode) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.stateProvinceCode : "--", " ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.postCode) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.address.postCode : "--", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Tel : ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.phone == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.phone.phoneNumber) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.phone == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.phone.phoneNumber : "--", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Email : ", (ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails == null ? null : ctx_r0.generateReceiptDetails.clientCompanyDetails.email : "--", "");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate((ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.paymentTransId) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.paymentTransId : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.invoiceNumber) ? ctx_r0.generateReceiptDetails == null ? null : ctx_r0.generateReceiptDetails.invoiceNumber : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r0.getFormArray().controls);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("src", ctx_r0.ownCompanyLogoImage, i0.ɵɵsanitizeUrl);
} }
function LibGenerateReceiptComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4, "Receipt No.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 1);
    i0.ɵɵelementStart(8, "p");
    i0.ɵɵtext(9, " If you have created the receipt and want to send it to the client upload a copy and send ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r1.generateReceiptDetails == null ? null : ctx_r1.generateReceiptDetails.receiptNumber) ? ctx_r1.generateReceiptDetails == null ? null : ctx_r1.generateReceiptDetails.receiptNumber : ctx_r1.getInvoiceNumber);
} }
class LibGenerateReceiptComponent {
    constructor(fb, cdr, generateReceiptService, CustomRadioButtonService, toasterService, uploadService, referenceLibraryService, dialogService, cRef, customDropdownService) {
        this.fb = fb;
        this.cdr = cdr;
        this.generateReceiptService = generateReceiptService;
        this.CustomRadioButtonService = CustomRadioButtonService;
        this.toasterService = toasterService;
        this.uploadService = uploadService;
        this.referenceLibraryService = referenceLibraryService;
        this.dialogService = dialogService;
        this.cRef = cRef;
        this.customDropdownService = customDropdownService;
        this.observableSubscription$ = new Subject();
        this.attorneyFirms = [];
        this.generateReceiptDetails = [];
        this.grandTotal = 0;
        this.previewBillingItems = [];
        this.invoiceRadioValue = "Generate Receipt";
        this.listDocumentReferenceData = [];
        this.showReferenceCodeSection = false;
        this.displaypopup = false;
        this.selectedField = 0;
        this.documentTypeDropdownCode = "";
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
        this.uploadedFiles = [];
        this.listDocumentTypes = [];
        this.configurations = {
            disableControls: false,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            postApiUrl: "",
            getApiUrl: "",
            deleteApiUrl: "",
            documentTypeDropdownCode: "",
        };
        this.otherName = "";
    }
    ngOnInit() {
        this.getModuleId = sessionStorage.getItem("moduleId");
        this.generateReceiptService
            .getMenuWithPermissionListById(this.getModuleId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            const selectedMenu = JSON.parse(sessionStorage.getItem("selectedMenu"));
            const menuId = this.formBuilderInfo.menuId || selectedMenu.value;
            this.userType = sessionStorage.getItem("userTypeRole");
            this.configurations.documentTypeDropdownCode = "OTHERDOCS";
            this.fileUploadConfigurations = {
                disableControls: false,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getDocTypeApiUrl: `/referenceLibrary/${this.documentTypeDropdownCode}`,
                getApiUrl: `/vd/formBuilder/fetchAll/uploadedDocs/`,
                postApiUrl: `/vd/formBuilder/uploadDoc/formData/company/${this.companyId}/module/${this.formBuilderInfo.moduleId}/menu/${menuId}/form/${this.formBuilderInfo.id}?`,
                deleteApiUrl: `/vd/formBuilder/formDataDocs/delete/`,
                documentTypeDropdownCode: this.documentTypeDropdownCode,
                isFormBuilder: true,
                fbFormDataId: this.dataFormId
                    ? this.dataFormId
                    : "genRecieptFileId" in sessionStorage
                        ? parseInt(sessionStorage.getItem("genRecieptFileId"))
                        : null,
            };
            if (this.fileUploadConfigurations) {
                this.configurations = Object.assign({}, this.fileUploadConfigurations);
                this.dataFormId = this.configurations.fbFormDataId
                    ? this.configurations.fbFormDataId
                    : "";
                this.getDocuments();
            }
        });
        this.group.addControl(this.inputParams.name, new FormGroup({
            selectedRadio: new FormControl(),
            invoiceNumber: new FormControl(),
            invoiceDate: new FormControl(),
            billedTocompany: new FormControl(),
            billingItemDTOs: new FormArray([]),
            receiptNumber: new FormControl(),
            currencyCode: new FormControl(),
            fileOwncopy: new FormControl(),
            uploadedFile: new FormControl(),
        }));
        this.invoiceForm = this.group.controls[this.inputParams.name];
        this.group.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
        this.invoiceForm.controls["selectedRadio"].setValue(this.invoiceRadio);
        this.subscription =
            this.CustomRadioButtonService.getInvoicingRadioChange().subscribe((data) => {
                this.invoiceRadio = data.radio;
                this.invoiceRadioValue = data.radio.name;
                this.invoiceForm.controls["selectedRadio"].setValue(this.invoiceRadio);
            });
        this.getGenerateReceiptDetails();
        this.getInvoiceNo();
    }
    getFormArray() {
        return this.invoiceForm.get("billingItemDTOs");
    }
    addBillingItemDTOs() {
        this.invoiceForm.controls["billingItemDTOs"].clear();
        var arrayControl = this.invoiceForm.get("billingItemDTOs");
        this.generateReceiptDetails.invoiceDetails.forEach((item) => {
            arrayControl.push(this.createBillingItem(item));
        });
        this.cdr.detectChanges();
    }
    createBillingItem(item) {
        return this.fb.group({
            chargeableAmt: item.chargeableAmt,
            billingItem: item.billingItem,
            hoursWorked: item.hoursWorked,
            taxAmt: item.taxAmt,
            totalAmt: item.totalAmt,
        });
    }
    getGenerateReceiptDetails() {
        this.getListId =
            "idToGetDetails" in sessionStorage
                ? parseInt(sessionStorage.getItem("idToGetDetails"))
                : null;
        this.generateReceiptService
            .getGenerateReceiptDetails(this.getListId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b, _c, _d, _e;
            this.generateReceiptDetails = response.data || null;
            const emails = ((_b = (_a = this.generateReceiptDetails) === null || _a === void 0 ? void 0 : _a.clientCompanyDetails) === null || _b === void 0 ? void 0 : _b.emails) || [];
            this.customDropdownService.sendEmails(emails);
            this.companyLogoImage = this.generateReceiptDetails.clientCompanyDetails
                ? "data:image/jpeg;base64," + ((_c = this.generateReceiptDetails.clientCompanyDetails) === null || _c === void 0 ? void 0 : _c.companyLogo)
                : null;
            this.ownCompanyLogoImage = this.generateReceiptDetails
                .employeeCompanyDetails
                ? "data:image/jpeg;base64," + ((_d = this.generateReceiptDetails.employeeCompanyDetails) === null || _d === void 0 ? void 0 : _d.companyLogo)
                : null;
            this.invoiceForm.controls["invoiceNumber"].setValue(this.generateReceiptDetails.invoiceNumber);
            this.invoiceForm.controls["billedTocompany"].setValue(this.generateReceiptDetails.clientCompanyDetails);
            this.invoiceForm.controls["invoiceDate"].setValue(this.generateReceiptDetails.invoiceDate);
            this.invoiceForm.controls["currencyCode"].setValue(this.generateReceiptDetails.currencyCode);
            this.selectedcurrencyicon = (_e = this.generateReceiptDetails.currencyCode) === null || _e === void 0 ? void 0 : _e.name;
            this.selectedCurrencyType = this.selectedcurrencyicon.split("-")[1];
            this.addBillingItemDTOs();
        });
    }
    getInvoiceNo() {
        this.generateReceiptService
            .getReceipteNo()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b;
            this.getInvoiceNumber = response.data || null;
            this.invoiceForm.controls["receiptNumber"].setValue(((_a = this.generateReceiptDetails) === null || _a === void 0 ? void 0 : _a.receiptNumber) ? (_b = this.generateReceiptDetails) === null || _b === void 0 ? void 0 : _b.receiptNumber : this.getInvoiceNumber);
        });
    }
    onUploadHandle(event, fubauto) {
        const file = event.files[0];
        this.group.controls[this.inputParams.name].patchValue({
            uploadedFile: event.files[0],
        });
        file.fileName = event.files[0].name;
        const payload = new FormData();
        payload.append("file", file, file.name);
        let apiUrl;
        this.configurations.documentTypeDropdownCode = "OTHERDOCS";
        apiUrl =
            `${this.configurations.postApiUrl}` +
                `${this.configurations.documentTypeDropdownCode
                    ? "documentCategory=" + this.configurations.documentTypeDropdownCode
                    : ""}` +
                `${this.dataFormId ? "&formDataId=" + this.dataFormId : ""}`;
        this.uploadService
            .uploadDocument(apiUrl, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.toasterService.success(response.message, 'Success');
            this.cRef.detectChanges();
            this.otherName = "";
            if (this.configurations.isFormBuilder) {
                this.dataFormId = response.data ? response.data.formDataId : "";
                this.generateReceiptService.formDataIdChanges.next({
                    dataFormId: this.dataFormId,
                });
            }
            this.getDocuments();
            if (this.configurations.isDocumentTypeRequired) {
                this.configurations.documentTypeDropdownCode = "";
            }
            fubauto.clear();
        });
    }
    getDocuments() {
        if (this.configurations.getApiUrl &&
            (!this.configurations.isFormBuilder ||
                (this.configurations.isFormBuilder && this.dataFormId))) {
            let apiUrl = this.configurations.getApiUrl;
            if (this.configurations.familyId) {
                apiUrl = `${this.configurations.getApiUrl}?familyId=${this.configurations.familyId}`;
            }
            if (this.configurations.isFormBuilder) {
                apiUrl = `${apiUrl}` + `${this.dataFormId}`;
            }
            this.uploadService
                .getUploadedDocument(apiUrl)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                this.uploadedFiles = Object.assign([], response.data);
                this.group.controls[this.inputParams.name].patchValue({
                    fileOwncopy: response.data[0].id,
                });
            });
        }
    }
    deleteDocumentTypeLis(input) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.uploadService
                    .deleteUploadDocument(this.configurations.deleteApiUrl + `${input.id}`)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((responseUploadedDocs) => {
                    this.toasterService.success(responseUploadedDocs.message, 'Success');
                    this.getDocuments();
                });
            }
        });
    }
    openDoc(item) {
        if (this.configurations.isFormBuilder) {
            const docPath = item.fileLocation;
            window.open(`${environment.appUrl}${docPath}`, "_blank");
        }
        else {
            const docPath = item.fileLocation.substring(23);
            window.open(`${environment.docs}${docPath}`, "_blank");
        }
    }
    download(file) {
        if (this.configurations.isFormBuilder) {
            this.uploadService.downloadDocuments(environment.appUrl + file.fileLocation, file.fileLocation);
        }
        else {
            this.uploadService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.subscription.unsubscribe();
    }
}
LibGenerateReceiptComponent.ɵfac = function LibGenerateReceiptComponent_Factory(t) { return new (t || LibGenerateReceiptComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(LibGenerateReceiptService), i0.ɵɵdirectiveInject(i3.CustomRadioButtonService), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.FileUploadLibraryService), i0.ɵɵdirectiveInject(i6.ReferenceLibraryService), i0.ɵɵdirectiveInject(i7.DialogService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i8.CustomDropdownService)); };
LibGenerateReceiptComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibGenerateReceiptComponent, selectors: [["lib-generate-receipt"]], inputs: { group: "group", inputParams: "inputParams", formBuilderInfo: "formBuilderInfo" }, decls: 5, vars: 3, consts: [[1, "row"], [1, "col-12"], [3, "formGroup"], ["class", "viewinvoice", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "viewinvoice"], [1, "row", "mt-3"], [1, "col-md-2"], [1, "p-3"], ["alt", "company-logo", 1, "companyLogoImage", 3, "src"], [1, "col-6", "mt-2", "text"], [1, "col-4", "mt-2", "pull-right"], [1, "mt-2"], [1, "row", "mt-3", "bg"], [1, "col-12", "mt-2", "ml-1", "mb-2"], [1, "divider"], [1, "row", "bg"], [1, "col-6", "mt-2"], [1, "mb-3", "mt-2"], [1, "col-6", "mt-3", "text-right"], ["formArrayName", "billingItemDTOs", 1, "row", "mt-3"], ["dataKey", "id", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "footer"], [1, "row", "d-flex", "footer", "justify-content-center", "align-items-center", "mb-3"], [1, "col-4"], [1, "col-2", "p-0", "pr-1", "text-right", "powered_content"], [1, "col-2", "nopadding"], ["alt", "own-company-logo", 3, "src"], [4, "ngIf"], [3, "formGroupName"], [1, "icon-style"], [1, "pos-bottom"], ["colspan", "5"], [1, "sub_head"], [1, "mr-5", "total_font"], [1, "icon-style", "pl-1", "pr-1"], [1, "sub_total", "mr-5"], [1, "col-12", "mt-2", "mb-2"]], template: function LibGenerateReceiptComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵtemplate(3, LibGenerateReceiptComponent_div_3_Template, 65, 18, "div", 3);
        i0.ɵɵtemplate(4, LibGenerateReceiptComponent_div_4_Template, 10, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.invoiceForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.invoiceRadioValue == "Generate Receipt");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.invoiceRadioValue != "Generate Receipt");
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i9.NgIf, i1$1.FormArrayName, i10.Table, i11.PrimeTemplate, i1$1.FormGroupName], pipes: [i9.DatePipe, i9.SlicePipe, NumberToWordsPipe], styles: [".label-cls[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-weight:600}.viewinvoice[_ngcontent-%COMP%]{border:1px solid #707070}.nopadding[_ngcontent-%COMP%]{padding:0!important;margin:0!important}table[_ngcontent-%COMP%]{text-align:left;font:normal normal 700 16px Source Sans Pro;letter-spacing:0;color:#505050;opacity:1}.bg[_ngcontent-%COMP%]{background:#edf4fb}td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{width:100%!important}td[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.p-input-icon-left[_ngcontent-%COMP%] > i[_ngcontent-%COMP%], .p-input-icon-right[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{position:absolute;top:0;margin-top:0}.footer[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:50px;width:80px}.receipt_logo[_ngcontent-%COMP%]{height:90px;width:180px}.powered_content[_ngcontent-%COMP%]{font-size:12px}.img-style[_ngcontent-%COMP%]{width:30px;height:30px}.address[_ngcontent-%COMP%]{font-style:normal}table[_ngcontent-%COMP%]{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{border:1px solid #ddd;text-align:left;padding:8px}.sub_total[_ngcontent-%COMP%]{text-transform:capitalize}.total_font[_ngcontent-%COMP%]{font-size:14px}.text[_ngcontent-%COMP%]{text-align:left;font:normal normal 700 44px/44px Source Sans Pro;letter-spacing:0;color:#505050;opacity:1;font-weight:700}.icon-style[_ngcontent-%COMP%]{font-size:16px}.divider[_ngcontent-%COMP%]{border:none;border-top:1px solid #d3d3d3;color:#fff;background-color:#fff;height:1px;width:100%}.icon-style[_ngcontent-%COMP%]{font-weight:600}.sub_head[_ngcontent-%COMP%]{display:inline-block;font-weight:700}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibGenerateReceiptComponent, [{
        type: Component,
        args: [{
                selector: "lib-generate-receipt",
                templateUrl: "./lib-generate-receipt.component.html",
                styleUrls: ["./lib-generate-receipt.component.scss"],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i0.ChangeDetectorRef }, { type: LibGenerateReceiptService }, { type: i3.CustomRadioButtonService }, { type: i4.ToastrService }, { type: i5.FileUploadLibraryService }, { type: i6.ReferenceLibraryService }, { type: i7.DialogService }, { type: i0.ChangeDetectorRef }, { type: i8.CustomDropdownService }]; }, { group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], formBuilderInfo: [{
            type: Input
        }] }); })();

class LibGenerateReceiptModule {
}
LibGenerateReceiptModule.ɵfac = function LibGenerateReceiptModule_Factory(t) { return new (t || LibGenerateReceiptModule)(); };
LibGenerateReceiptModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibGenerateReceiptModule });
LibGenerateReceiptModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibGenerateReceiptModule, { declarations: [LibGenerateReceiptComponent, NumberToWordsPipe], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [LibGenerateReceiptComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibGenerateReceiptModule, [{
        type: NgModule,
        args: [{
                declarations: [LibGenerateReceiptComponent, NumberToWordsPipe],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [LibGenerateReceiptComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-generate-receipt
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibGenerateReceiptComponent, LibGenerateReceiptModule, LibGenerateReceiptService };
//# sourceMappingURL=lib-generate-receipt.js.map
